<template>
  <b-card
    no-body
    class="mr-1 noborder-card"
    v-bind:class="cssType === 'main-product' ? 'noborder-card-brd-w-2' : ''"
    v-show="showProduct"
  >
    <b-card-header
      header-tag="header"
      class="p-1 h6"
      :class="{ 'py-0': bold !== 'true' }"
      role="tab"
    >
      <span
        @click="toggleChecked"
        :class="{ checkboxPointer: !wasCheckedOption && !disabled }"
      >
        <span v-if="wasCheckedOption || isCheckedOption || disabled">
          <img
            v-if="isCheckedOption"
            :src="styles.checkbox_new"
            alt="check"
            class="pb-1"
          />
          <img
            v-else-if="wasCheckedOption"
            :src="styles.checkbox_old"
            alt="check"
            class="pb-1"
            @click="productMandatory"
          />

          <img v-else-if="disabled" :src="styles.x" alt="x" class="pb-1" />
        </span>
        <span v-else>
          <input type="checkbox" />
        </span>
        <span
          v-html="label"
          :class="{ 'font-weight-bold': bold === 'true' || clientOwns }"
        ></span>
      </span>
      <span v-b-toggle="accordionId">
        <span class="when-closed px-2">
          <i class="fas fa-chevron-down"></i
        ></span>
        <span class="when-open px-2"
          ><i class="fas fa-chevron-up when-open"></i
        ></span>
      </span>
      <b-form-select
        v-if="(type === 'B' && showBSelect) || (type === 'P' && showPSelect)"
        v-model="selected"
        :options="products"
        :disabled="disabledSelect"
        value-field="key"
        text-field="label_price"
        class="w-auto font-weight-bold py-0 my-0"
      ></b-form-select>
      <span
        v-if="isChecked"
        class="ml-3 mr-3 mt-2"
        :class="{ 'float-right': type !== 'B' }"
      >
        <span
          v-if="
            isCheckedOption &&
            isCheckedOption.OLD_NETTO &&
            isCheckedOption.NETTO > 0 &&
            isCheckedOption.OLD_NETTO > isCheckedOption.NETTO
          "
        >
          <span class="text-danger line-through px-2"
            >{{ commaFormat(isCheckedOption.OLD_NETTO) }} zł</span
          >
        </span>
        <span v-if="isCheckedOption && isCheckedOption.NETTO > 0"
          >{{ commaFormat(isCheckedOption.NETTO) }} zł</span
        >

        <span
          v-if="
            isCheckedOption &&
            isCheckedOption.OLD_NETTO &&
            isCheckedOption.NETTO > 0 &&
            isCheckedOption.OLD_NETTO > isCheckedOption.NETTO
          "
        >
          <span class="small">
            (Najniższa cena z 30 dni przed obniżką:
            <span v-if="isCheckedOption.OMNIBUS_NETTO">{{
              isCheckedOption.OMNIBUS_NETTO
            }}</span>
            <span else>{{ isCheckedOption.OLD_NETTO }}</span> zł)
          </span>
        </span>
      </span>
    </b-card-header>
    <b-card-body>
      <b-collapse :id="accordionId" :accordion="accordionId" role="tabpanel">
        <b-card-text>
          <div class="mt-1" v-html="description"></div>
        </b-card-text>
      </b-collapse>
    </b-card-body>
  </b-card>
</template>

<script>
import { modulesOptions } from '../../config/modulesWithOptions';
import { mapGetters } from 'vuex';

export default {
  name: 'ProductSelectRow',
  props: {
    styles: {},
    products: {},
    type: { type: String },
    cssType: { type: String, default: '' },
    wasCheckedOption: {},
    isCheckedOption: {},
    disabled: { type: Boolean, default: false },
    accordionId: { type: String },
    bold: { type: String, default: 'false' },
    accountantAdd: { default: null },
    isAccountant: { type: Boolean, default: false },
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapGetters({
      program: 'getProgram',
      client: 'auth/client',
    }),
    accountant() {
      return (
        this.client.MDS !== null &&
        this.client.MDS !== '' &&
        this.client.MDS.split('').includes('B')
      );
    },
    showBSelect() {
      return (
        this.type === 'B' &&
        ((this.wasCheckedOption && this.wasCheckedOption !== 'B3') ||
          (this.isCheckedOption &&
            this.isCheckedOption.key.indexOf('B') !== false))
      );
    },
    showPSelect() {
      let showP =
        this.type === 'P' &&
        ((this.wasCheckedOption && this.wasCheckedOption !== 'P3') ||
          (this.isCheckedOption != null &&
            this.isCheckedOption.key.indexOf('P') !== false));
      return showP;
    },
    showProduct() {
      return !(
        (this.type === 'P' && this.wasCheckedOption === 'P3') ||
        (this.type === 'B' && this.wasCheckedOption === 'B3')
      );
    },
    label() {
      if (this.wasCheckedOption && this.wasCheckedOption === 'B3') {
        return 'Liczba obsługiwanych firm - posiadasz plan bez limitu firm';
      }
      if (this.program === 'sam' && this.type === 'B') {
        return 'SKP<sup>®</sup> Start BIURO - obsługa większej liczby firm';
      } else if (this.accountant && this.type === 'B') {
        return 'Zwiększ liczbę obsługiwanych firm';
      } else if (
        this.program === 'skp' &&
        this.type === 'B' &&
        !this.accountant
      ) {
        return 'Chcę zwiększyć liczbę obsługiwanych firm:';
      } else {
        return modulesOptions[this.type].label;
      }
    },
    description() {
      if (this.wasCheckedOption && this.wasCheckedOption === 'B3') {
        return 'Posiadasz wersję, która umożliwia obsługę nieograniczonej liczby firm.';
      }
      if (this.program === 'skp' && !this.accountant && this.type === 'B') {
        let version =
          this.client.SPR < '2021-12-01' ? 'trzech firm.' : 'jednej firmy.';
        return (
          'SKP<sup>®</sup> Firma w wersji, którą posiadasz umożliwia obsługę ' +
          version +
          'W tym miejscu możesz zwiększyć liczbę obsługiwanych Firm, przechodząc na wersję SKP<sup>®</sup> Biuro. ' +
          'Jest to idealne rozwiązanie dla spółek wieloosobowych oraz firm, które przekształcają działalność na biuro rachunkowe.' +
          '<br><p class="text-info">Uwaga! Zaznaczenie tego rozszerzenia powoduje przejście z wersji SKP<sup>®</sup> Firma na SKP<sup>®</sup> Biuro ' +
          'i tym samym konieczna będzie dopłata różnicy do już posiadanych modułów i dodatków. ' +
          'Zostaną one automatycznie zaznaczone i zobaczysz kwotę dopłaty. Możesz także dokupić nowe, ' +
          'z których nie korzystałeś do tej pory.<br>' +
          'Do wyboru trzy plany: obsługa do 10 firm, do 50 firm i bez limitu.</p>'
        );
      } else if (
        this.program === 'skp' &&
        this.accountant &&
        this.type === 'B'
      ) {
        return 'W tym miejscu decydujesz o liczbie obsługiwanych firm. Do wyboru masz trzy plany: obsługa do 10 firm, do 50 firm i bez limitu. Pamiętaj, że jeżeli wybierzesz niższy plan, to w dowolnym momencie możesz zmienić jego wariant na wyższy.';
      } else {
        let lastPart =
          this.wasCheckedOption && this.wasCheckedOption === 'P3'
            ? '<p class="text-info">Posiadasz plan bez limitu osób.</p>'
            : '<p class="text-info">Do wyboru trzy plany: obsługa do 3 osób, do 20 osób i bez limitu.</p>';

        return (
          'W module wyliczysz wynagrodzenia na podstawie różnych umów, obliczysz wynagrodzenia za czas choroby i inne świadczenia, automatyczne zaksięgujesz wynagrodzenia, ' +
          'wystawisz deklaracje ZUS (DRA, RCA, RSA, RZA) i wyeksportujesz je do programu Płatnik, sporządzisz również RMUA, ZUS -3, i ZUS - 3A oraz ZUS-3B, a także ZUS - 7, ZUS Z-17.<br/><br/> ' +
          'Dodatkowo program tworzy deklaracje PIT i umożliwia ich e-wysyłkę z podpisem elektronicznym i bez (11-także zbiorczo, 4R, 8AR), kilka list płac (1 główna i 2 dodatkowe) i karty wynagrodzeń.<br/><br/>' +
          lastPart
        );
      }
    },
    isChecked: {
      get() {
        return !!this.isCheckedOption;
      },
      set(value) {
        if (!this.isCheckedOption && !this.disabled) {
          let selected = this.products.find(
            (item) => item.key === this.type + '3'
          );
          this.$emit('addproduct', selected);
        } else if (this.isCheckedOption) {
          this.$emit('addproduct', this.isCheckedOption);
        }
      },
    },
    selected: {
      get() {
        return this.isCheckedOption
          ? this.isCheckedOption.key
          : this.wasCheckedOption
          ? this.wasCheckedOption
          : this.type + '3';
      },
      set(value) {
        if (
          this.isCheckedOption !== null &&
          ((this.type === 'P' &&
            this.wasCheckedOption &&
            this.wasCheckedOption === value) ||
            (this.type === 'B' &&
              this.wasCheckedOption &&
              this.wasCheckedOption === value))
        ) {
          this.$emit('addproduct', this.isCheckedOption);
        } else {
          let selected = this.products.find((item) => item.key === value);
          this.$emit('addproduct', selected);
        }
      },
    },
    disabledSelect() {
      return this.wasCheckedOption === this.type + '3';
    },
    clientOwns() {
      return (
        this.client.MDS !== null &&
        this.client.MDS !== '' &&
        this.client.MDS.split('').includes(this.type) &&
        this.accountantAdd &&
        !this.client.MDS.split('').includes('B') &&
        !this.isCheckedOption
      );
    },
  },
  methods: {
    toggleChecked() {
      this.isChecked = !this.isCheckedOption;
    },
    commaFormat(value) {
      return Number(value).toLocaleString('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    productMandatory() {
      this.$bvModal.msgBoxOk(
        'Opcja niemożliwa do samodzielnego odznaczenia. Aby zrezygnować lub zmienić wybraną pozycję skontaktuj się z BOK.',
        {
          title: '',
          size: 'sm',
          buttonSize: 'sm',
          footerClass: 'p-2',
          hideHeaderClose: false,
        }
      );
    },
  },
};
</script>

<style scoped></style>
